/**
 * @desc 财务画像-基础信息-人员信息
 */
import style from './personnelMessage.scss';
import React, { PureComponent } from 'react';
import GroupBox from '../../../common/groupBox/GroupBox';
import { Table, Row, Col, Spin } from 'antd';
import BBDLineBar from '../../../common/echarts/BBDLineBar';
import BBDPie from '../../../common/echarts/BBDPie';
import NoData from '../../../common/noData/NoData';
import Recruitment from './Recruitment';
import { isNotEmpty, isArray, isNumber, isEmpty } from '../../../../utils/util';
import { numberFixed } from '../../../../utils/formatter';
import { fieldAnomaly } from '../../../../utils/formatter';
import { commonRequest, commonPieOption } from '../../common/commons';
import { getEducation, executivesWage } from '../../../../services/financialPicture/baseInfo';

export default class PersonnelMessage extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            tableData: [],
            positionData: [],
            personNum: [],
            wageLoading: false,
            legend: {
                orient: 'vertical',
                x: 'left',
                left: '56%',
                height: 170
            },
            center: ['35%', '51%'],
            loading: false
        };
    }

    componentDidMount() {
        this.educationPort();
        this.executivesWagePort();
    }

    // 高管薪酬表格表头
    executiveEducation = () => {
        return [
            {
                title: '年份/万元',
                dataIndex: 'enddate'
            },
            {
                title: '董事长薪酬',
                dataIndex: 'ceosalary'
            },
            {
                title: '前三名高管薪酬总额',
                dataIndex: 'topthreemanagersalary'
            },
            {
                title: '前三名董事薪酬总额',
                dataIndex: 'topthreedirectorsalary'
            },
            {
                title: '财务总监薪酬',
                dataIndex: 'financialofficersalary'
            },
            {
                title: '总经理薪酬',
                dataIndex: 'generalmangsalary'
            },
            {
                title: '净利润',
                dataIndex: 'netprofit',
                render: val => numberFixed((val / 10000)) 
            }
        ];
    };

    // 高管薪酬
    executivesWagePort = () => {
        this.setState({
            wageLoading: true
        });
        executivesWage(commonRequest()).then((data) => {
            data = data || {};
            this.setState({
                wageLoading: false,
                tableData: this.wageFn(data)
            });
        }).catch(() => {
            this.setState({
                wageLoading: false
            });
        });
    };

    // 高管薪酬情况表格数据 和 柱状图数据
    wageFn = (data) => {
        let targeYear = {}, objTwo = {}, compensation = [], average = [], tableData = [];
        for (let d in data) {
            if (isArray(data[d])) {
                data[d].forEach((item, index) => {
                    if (index === 0) {
                        targeYear[d] = fieldAnomaly(item);
                        isNumber(item) ? compensation.push(fieldAnomaly(d !== 'netprofit' ?  item : '')) : '';
                    } else {
                        objTwo[d] = fieldAnomaly(item);
                    }
                });
            } else {
                average.push(fieldAnomaly(d !== 'avgnetprofit' ? data[d] : ''));
            }
        }
        tableData.push(targeYear, objTwo);
        const option = {
            legend: {
                top: 250,
                left: '44%'
            },
            grid: {
                bottom: 40
            },
            yAxis: [{
                color: '#88A3B4',
                nameTextStyle: {
                    color: '#88A3B4'
                }
            }],
            barData: [
                {
                    name: '薪酬', data: compensation
                },
                {
                    yAxisIndex: 1,
                    name: '行业平均薪酬', data: average
                }
            ],
            category: ['董事长', '前三名高管', '前三名董事', '财务总监', '总经理 '],
            color: ['#2365C4', '#F99248']
        };
        return { data: tableData, option: isEmpty(compensation) && isEmpty(average) ? {} : option };
    };

    // 高管学历数据
    educationPort = () => {
        this.setState({
            loading: true
        });
        getEducation(commonRequest()).then((data) => {
            data = data || {};
            this.setState({
                loading: false,
                personNum: this.personNum(data.positionComposite || {}),
                positionData: this.positionFn(data.educationComposite || {})
            });
        }).catch(() => {
            this.setState({
                loading: false
            });
        });
    };

    // 职位构成
    personNum = (data) => {
        const { legend, center } = this.state;
        let pieData = [
            { name: '行政人员人数', value: data.execustaffnum },
            { name: '财务人员人数', value: data.financialstaffnum },
            { name: '管理人员人数', value: data.managestaffnum },
            { name: '其他专业人员人数', value: data.othermajornum },
            { name: '生产人员人数', value: data.productionstaffnum },
            { name: '销售人员人数', value: data.salestaffnum },
            { name: '技术人员人数', value: data.techstaffnum }
            ], notNull = [];
        pieData.forEach(item => {
            if (isNotEmpty(item.value) && item.value > 0) {
                notNull.push({ name: item.name, value: item.value });
            }
        });
        return commonPieOption(legend, center, '', notNull);
    };

    // 学历分布
    positionFn = (data) => {
        const { legend, center } = this.state;
        let person = [
            { name: '专科生人数', value: data.collegenum },
            { name: '高中生人数', value: data.highschoolnum },
            { name: '本科生人数占比', value: data.udergradnum },
            { name: '研究生人数', value: data.postgradnum },
            { name: '其他学历人数', value: data.otheredunum }
            ],
            notNull = [];
        person.forEach(item => {
            if (isNotEmpty(item.value) && item.value > 0) {
                notNull.push({ name: item.name, value: item.value });
            }
        });
        return commonPieOption(legend, center, '', notNull);
    };

    render() {
        const { tableData, wageLoading, loading, personNum, positionData } = this.state;
        const { data, option } = tableData;
        return (
            <div>
                <GroupBox title="高管薪酬情况" id="compensation-edu">
                    <Table
                        pagination={false}
                        loading={wageLoading}
                        bordered
                        rowKey="enddate"
                        dataSource={data}
                        columns={this.executiveEducation()}
                    />
                    <div className={style.personMs}>
                        <Row>
                            <Col span={24}>
                                <div className={style.subTitle}>高管薪酬情况</div>
                                <div className={style.compensation}>
                                    {wageLoading ? <Spin /> :
                                        isNotEmpty(option) ?
                                            <BBDLineBar option={option} /> :
                                            <NoData />
                                    }
                                </div>
                            </Col>
                        </Row>
                    </div>
                </GroupBox>
                <GroupBox title="员工构成" id="person-contrast">
                    <div className={style.personMs}>
                        <Row>
                            <Col span={12}>
                                <div className={style.subTitle}>职位构成</div>
                                <div className={style.educationInfo}>
                                    {loading ? <Spin />
                                        : isNotEmpty(positionData) ?
                                            <BBDPie option={positionData} /> : <NoData />
                                    }
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className={style.subTitle}>人数</div>
                                <div className={style.educationInfo}>
                                    {loading ? <Spin />
                                        : isNotEmpty(personNum) ?
                                            <BBDPie option={personNum} /> : <NoData />
                                    }
                                </div>
                            </Col>
                        </Row>
                    </div>
                </GroupBox>
                <Recruitment />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/personnelMessage/PersonnelMessage.jsx